
export default {
  name: 'IconArrowNarrow-10x8',
};
